var _path, _g, _path2, _path3, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnlyguidesTextLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 103 10"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "onlyguides-text-logo_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 0h9.848v10H.5V0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#onlyguides-text-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.423 7.937c.828 0 1.434-.234 1.818-.7.383-.468.575-1.198.575-2.192 0-1.084-.192-1.85-.575-2.297-.384-.446-.99-.67-1.818-.67-.839 0-1.45.224-1.833.67-.384.447-.575 1.213-.575 2.297 0 .994.191 1.724.575 2.191.383.467.994.7 1.833.7zM5.424 10c-1.606 0-2.828-.401-3.666-1.205C.919 7.992.5 6.742.5 5.045c0-1.797.42-3.087 1.258-3.87C2.596.39 3.818 0 5.424 0 7.03 0 8.251.39 9.09 1.175c.839.783 1.258 2.073 1.258 3.87 0 1.697-.42 2.947-1.258 3.75C8.251 9.599 7.03 10 5.424 10z",
    fill: "#000"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.446 9.85V.15h2.117l4.203 5.799V.151h2.485v9.698H20.12l-4.203-5.783V9.85h-2.47zM25.656 9.85V.15h2.47v7.832h4.663v1.867h-7.133zM36.272 9.85V6.28L32.728.15h2.578l2.209 4.022L39.724.15H42.3l-3.544 6.13v3.568h-2.485zM59.683 10c-.92 0-1.72-.146-2.401-.437-.68-.291-1.206-.723-1.58-1.295-.373-.572-.56-1.275-.56-2.108V.15h2.47v5.784c0 .672.179 1.175.537 1.506.358.33.869.497 1.534.497.664 0 1.176-.166 1.534-.497.358-.331.537-.834.537-1.506V.15h2.47v6.01c0 .833-.187 1.536-.56 2.108-.374.572-.9 1.004-1.58 1.295-.68.291-1.48.437-2.401.437z",
    fill: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "onlyguides-text-logo_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 103,
    height: 10
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 10H103V0H.5v10z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#onlyguides-text-logo_svg__b)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.55 9.849h2.47V.15h-2.47V9.85zM75.895 7.982h1.473c.532 0 .98-.078 1.343-.233.362-.156.638-.445.828-.867.189-.421.284-1.029.284-1.822 0-.803-.085-1.423-.254-1.86-.168-.437-.434-.743-.797-.919-.363-.175-.831-.263-1.404-.263h-1.472v5.964zm-2.468 1.867V.15h4.28c1.001 0 1.845.164 2.53.49.685.326 1.207.848 1.565 1.567.357.717.537 1.669.537 2.853 0 1.667-.391 2.882-1.174 3.645-.782.763-1.935 1.144-3.459 1.144h-4.28zM85.436 9.85V.15h7.286v1.868h-4.816v2.033h4.25V5.95h-4.25v2.033h4.816v1.867h-7.285zM98.888 10c-.654 0-1.266-.048-1.834-.143a6.15 6.15 0 01-1.465-.414V7.379c.45.191.949.347 1.497.467.546.12 1.066.181 1.556.181.614 0 1.072-.055 1.373-.165.302-.111.453-.352.453-.724 0-.25-.075-.451-.223-.602-.148-.15-.389-.284-.72-.4a24.871 24.871 0 00-1.358-.413c-.675-.201-1.212-.424-1.61-.67-.4-.246-.686-.545-.86-.896-.174-.352-.26-.784-.26-1.295 0-.924.337-1.632 1.012-2.124C97.124.246 98.12 0 99.439 0c.573 0 1.131.043 1.673.128s.982.183 1.319.294V2.5a7.295 7.295 0 00-2.623-.497c-.552 0-1 .05-1.342.15-.343.101-.514.332-.514.694 0 .21.061.378.184.504s.335.239.637.339c.301.1.713.22 1.234.361.808.211 1.427.465 1.856.76.43.297.727.638.89 1.025.164.387.246.82.246 1.302 0 .854-.338 1.544-1.013 2.071-.675.527-1.708.791-3.098.791zM48.236 5.858h2.132v1.838c-.512.16-1.064.24-1.657.24-.9 0-1.58-.228-2.04-.685-.46-.457-.69-1.162-.69-2.115 0-1.045.242-1.815.728-2.312.486-.497 1.26-.746 2.324-.746.501 0 .99.03 1.465.09.075.01.15.023.223.035L51.848.415a8.62 8.62 0 00-1.365-.31A11.47 11.47 0 0048.849 0c-1.77 0-3.109.451-4.019 1.355-.91.904-1.365 2.164-1.365 3.78 0 1.546.445 2.744 1.334 3.592.89.849 2.189 1.273 3.897 1.273.91 0 1.674-.088 2.293-.264.618-.175 1.102-.374 1.45-.595V4.337h-3.245l-.959 1.521z"
  }))));
}
export default __webpack_public_path__ + "static/svg/onlyguides-text-logo.svg";
export { SvgOnlyguidesTextLogo as ReactComponent };